module.exports = __webpack_public_path__ + "static/media/home01.b33adb28.png";